import { redirect, createFileRoute } from '@tanstack/react-router';

/** The org-level White Glove area has one view; `/tasks` is it. */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/white-glove/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/dashboard/o/$orgId/white-glove/tasks', params });
  },
});
